export default {"src":"/_next/static/media/features-mobile-app.4fe5433b.svg","height":59,"width":58,"blurWidth":0,"blurHeight":0};